import type { Nullable } from 'primereact/ts-helpers';

export function goToViewPayment(paymentId: number) {
  return `/main/payments/${paymentId}/view`;
}

export function goToViewPayment_customer(
  paymentId: number,
  guid: Nullable<string>,
) {
  return `/main/${guid}/payments/${paymentId}/view`;
}

export function goToViewCredit(creditId: number) {
  return `/main/credits/${creditId}/view`;
}

export function goToAddPayment({ customerId }: { customerId?: number }) {
  return `/main/payments/add${customerId ? `?customerId=${customerId}` : ''}`;
}

export function goToPaymentList_customer(guid: Nullable<string>) {
  return `/main/${guid}/payments/list`;
}
